const audioMap = {
  welcome: '/assets/audio/welcome.mp3',
  more: '/assets/audio/explore.mp3',
  waypasthappy: '/assets/audio/WannaFeelWayPastHappy.mp3',
  play: '/assets/audio/play.mp3',
  pastfun: '/assets/audio/past-fun.mp3'
}

export default audioMap